import { gql } from 'graphql-request'

export const NEW_BOOKS_HOME = gql`
  query NewBooksHome {
    newBooksHome {
      id
      writer
      coverImgPath
      coverResizeImgPath
      cover
      title
      publishedChapterCount
      viewCount
      likeCount
      commentCount
      isEnded
      hasSalePromotions
      buyAllChaptersPromotion {
        startDate
        endDate
        discountType
        discountPercentage
      }
      readFreePromotion {
        startedAt
        endedAt
      }
      bookBadges {
        badgeCategoryId
        badgeImageUrl
      }
      bookChapterCampaignHeader {
        minSellingPrice
        totalChapter
        startedAt
        endedAt
      }
      category {
        id
        name
      }
      penName {
        firstPenName
        user {
          id
          displayName
          profilePageSlug
          avatarImgPath
          writer {
            affiliation
            status
          }
        }
      }
      tags {
        id
        name
      }
      bookType
      writingType
      publishedAt
      isTranslated
      isEpub
      isPdf
      rating {
        id
        name
      }
    }
  }
`
